import { api } from "@/features/utils/fetch-server";
import type {
  Service,
  CreateServiceRequest,
  UpdateServiceRequest,
} from "../types";

export class ServicesAPI {
  static async listServices(clientId: string) {
    const response = await api.get<{ services: Service[] }>(
      `/api/calendars/v1/${clientId}/services`,
    );
    return response.services;
  }

  static async getService(clientId: string, serviceId: string) {
    const response = await api.get<{ service: Service }>(
      `/api/calendars/v1/${clientId}/services/${serviceId}`,
    );
    return response.service;
  }

  static async createService(clientId: string, data: CreateServiceRequest) {
    const response = await api.post<{ service: Service }, CreateServiceRequest>(
      `/api/calendars/v1/${clientId}/services`,
      data,
    );
    return response.service;
  }

  static async updateService(
    clientId: string,
    serviceId: string,
    data: UpdateServiceRequest,
  ) {
    const response = await api.put<{ service: Service }, UpdateServiceRequest>(
      `/api/calendars/v1/${clientId}/services/${serviceId}`,
      data,
    );
    return response.service;
  }

  static async deleteService(
    clientId: string,
    serviceId: string,
  ): Promise<void> {
    await api.delete(`/api/calendars/v1/${clientId}/services/${serviceId}`);
  }
}
